import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useBrandTheme, { useRelations } from '@hooks/useBrandTheme'

const BrandThemeListItem = (props) => {
  const { brandTheme, brandTheme: { id, title } } = props

  const { brand } = useRelations(brandTheme)

  const brandThemePayload = useBrandTheme(brandTheme)
  const {
    callbacks: { createOrEditBrandTheme },
  } = brandThemePayload

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditBrandTheme()}
      secondaryText={brand.title}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

BrandThemeListItem.propTypes = {
  brandTheme: PropTypes.object.isRequired,
}

export default BrandThemeListItem
